import { MapConfigTypeToConfigKeyMap } from '@nova/configs';
import { EGameConfigs, IMapConfigEntry, IMapConfigEntryDomination } from '@nova/types';

import { fetchCombatGameMaps } from './maps-fetch';

// TODO: Outpost Run map entries are plain `IMapConfigEntry` here; richer Tiled-side structs may merge later (config + map data siblings).

export class MapRepository {
  private _actionGameMapConfigs?: MapConfigTypeToConfigKeyMap;

  public constructor(actionGameMapConfigs?: MapConfigTypeToConfigKeyMap) {
    this._actionGameMapConfigs = actionGameMapConfigs;
  }

  public async init(gameAPIEndpoint: string): Promise<void> {
    if (this._actionGameMapConfigs) { return; }
    this._actionGameMapConfigs = await fetchCombatGameMaps(gameAPIEndpoint);
  }

  public getOrMapsCopied(): IMapConfigEntry[] {
    const orMaps = structuredClone(this._actionGameMapConfigs?.[EGameConfigs.MAPS_OR]);
    if (!orMaps?.length) {
      throw new Error(`this._actionGameMapConfigs does not have any entries for key EGameConfigs.MAPS_OR`);
    }

    return orMaps;
  }

  public findMapByIdOr(mapId: string): IMapConfigEntry | undefined {
    return this._actionGameMapConfigs?.[EGameConfigs.MAPS_OR].find(({ id }) => id === mapId);
  }

  public findKnownMapByIdOr(mapId: string): IMapConfigEntry {
    const map = this._actionGameMapConfigs?.[EGameConfigs.MAPS_OR].find(({ id }) => id === mapId) as IMapConfigEntry;
    if (!map) { throw new Error(`Could not find map based on mapId <${mapId}>`); }
    return map;
  }

  public getDominationMapsCopied(): IMapConfigEntryDomination[] {
    const domMaps = structuredClone(this._actionGameMapConfigs?.[EGameConfigs.MAPS_DOMINATION]);
    if (!domMaps?.length) {
      throw new Error(`this._actionGameMapConfigs does not have any entries for key EGameConfigs.MAPS_DOMINATION`);
    }

    return domMaps;
  }

  public findByIdDomination(mapId: string): IMapConfigEntryDomination | undefined {
    return this._actionGameMapConfigs?.[EGameConfigs.MAPS_DOMINATION].find(({ id }) => id === mapId);
  }
}
